import type { IconPrimitives } from '../../../icons/types';

export const webPrimitives: IconPrimitives = {
  Svg: 'svg',
  Path: 'path',
  Circle: 'circle',
  Rect: 'rect',
  Ellipse: 'ellipse',
  defaultColor: 'currentColor',
};
